module.exports = __webpack_public_path__ + "img/storage-none.f07b1aee.svg";